import { generateAbsenceUrlBaseV2 } from "utils/utils";
import type { ApiCallerT } from "shared/infrastructure/api/types";
import type {
  CollaboratorAccrualsApiT,
  DeleteCollaboratorAccrualsResponseT,
  GetCollaboratorAccrualsResponseT,
  UpdateCollaboratorAccrualsResponseT,
} from "../types/collaboratorAccruals.types";

export const createCollaboratorAccrualsApi = (
  apiCaller: ApiCallerT,
): CollaboratorAccrualsApiT => ({
  getAll: async ({ collaboratorId, colaboraInstanceId }) => {
    const url = generateAbsenceUrlBaseV2(
      `collaborators/${collaboratorId}/accruals`,
    );

    const response = await apiCaller<GetCollaboratorAccrualsResponseT>(
      url,
      "GET",
      {},
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
  delete: async (dto, colaboraInstanceId) => {
    const url = generateAbsenceUrlBaseV2("accruals");

    const response = await apiCaller<DeleteCollaboratorAccrualsResponseT>(
      url,
      "DELETE",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
  update: async (dto, colaboraInstanceId) => {
    const url = generateAbsenceUrlBaseV2("accruals");

    const response = await apiCaller<UpdateCollaboratorAccrualsResponseT>(
      url,
      "PUT",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
});
